export default () => ({
    email: "",
    limit: 5,
    pubblicityHome: false,
    pubblicityResult: false,
    zone: 'home'
})